import React, { useEffect, useContext, useState } from "react";
import DataTable from "core/ui/data-table";
import { useHistory } from "react-router-dom";
import SessionContext from "SessionContext";
import ProgressLoader from "../partials/progress-loader";
import { animatedStyle } from "../core/ui/forms/file-uploader";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert
} from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { ipv4Regex } from "../core/utils/validate-ip-address";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import duration from 'dayjs/plugin/duration';
import ConfirmSuccess from "../core/ui/confirm-success";
import ConfirmDelete from "core/ui/confirm-delete";
dayjs.extend(isBetween);
dayjs.extend(duration);

export const nameStyle = {
  color: '#4a65a5',
  fontWeight: '300'
}

const CompanyApiAccess = (props) => {
  const session = useContext(SessionContext);
  const history = useHistory();

  const [companyInfo, setCompanyInfo] = useState();
  const [editUrl, setEditUrl] = useState({id: "", name: ""});
  const [isLoadingLicenses, setIsLoadingLicenses] = useState(true);
  const [createApiIsOpen, setCreateApiIsOpen] = useState(false);
  const [createIpIsOpen, setCreateIpIsOpen] = useState(false);
  const [editIpIsOpen, setEditIpIsOpen] = useState(false);
  const [editingIp, setEditingIp] = useState();
  const [ipToDelete, setIpToDelete] = useState();
  const [showApiCreateSuccess, setShowApiCreateSuccess] = useState(false);
  const [showApiDeleteSuccess, setShowApiDeleteSuccess] = useState(false);
  const [showApiModalDelete, setApiShowModalDelete] = useState(false);
  const [showIpModalDelete, setIpShowModalDelete] = useState(false);
  const [showIpCreateSuccess, setShowIpCreateSuccess] = useState(false);
  const [showIpDeleteSuccess, setShowIpDeleteSuccess] = useState(false);
  const [showIpUpdateSuccess, setShowIpUpdateSuccess] = useState(false);
  const [apiToDelete, setApiToDelete] = useState();
  const [apiToDeleteLabel, setApiToDeleteLabel] = useState("");
  const [reloadTables, setReloadTables] = useState(false);

  const table_columns_ip = [{ header: "IP Address", key: "ip_address" }];
  const table_columns_api = [
    { header: "API Key", key: "api_key" },
    { header: "Start", key: "start_date", render: (value) => {
      if(value.start_date) {
        return value.start_date;
      } else {
        return dayjs(value.expiration_date).subtract(1, "year").format('MMMM DD YYYY')
      }
    } },
    { header: "Expiration", key: "expiration_date" },
    { header: "Current", key: "current", render: (value) => {
      if( dayjs().isBetween( dayjs(value.start_date), dayjs(value.expiration_date).add(1, 'day') ) ) {
        return <i className="bi bi-check-circle"/>;
      } else {
        return "";
      }
    }},
  ];

  const table_actions_ip = (_data) => {
    return (
      <ul className="action-menu">
        <li>
          <button type="button" className="btn btn-link btn-sm"
            onClick={() => onEditIp( _data )}
          >
            <i className="bi bi-pencil"></i> Edit
          </button>
        </li>
        &nbsp;
        <li>
          <button type="button" className="btn btn-link btn-sm" onClick={() => onDeleteIpAddress(_data)}>
            <i className="bi bi-trash"></i> Delete
          </button>
        </li>
      </ul>
    )
  };

  const table_actions_api = (_data) => (
    <ul className="action-menu">
      <li>
        <button type="button" className="btn btn-link btn-sm" onClick={() => onDeleteApiKey(_data)}>
          <i className="bi bi-trash"></i> Delete
        </button>
      </li>
    </ul>
  );

  useEffect(() => {
    session.query("companies/get", { id: props.args.company_id })
           .then((response) => {
              setCompanyInfo(response);
              setCompanyDetailsArgs(response);
            })
    // eslint-disable-next-line
  }, [props.args.company_id])

  const setCompanyDetailsArgs = (info) => {
    setEditUrl({id: info.id, name: info.name});
    setIsLoadingLicenses(false);
  };

  const backToCompanyDetails = () => {
    if(editUrl.id) {
      history.push(`/admin-company-form#company_id=${editUrl.id}`);
    } else {
      history.push("/admin-companies");
    }
  }

  const toggleCreateNewApi = () => {
    setCreateApiIsOpen(!createApiIsOpen);
  }

  const toggleCreateNewIp = () => {
    setCreateIpIsOpen(!createIpIsOpen);
  }

  const toggleEditIp = () => {
    setEditIpIsOpen(!editIpIsOpen);
  }

  /* 
   * API functions 
  */

  const onCreateNewApi = (_key, start_d, end_d) => {
    let _data = {
      company_id: props.args.company_id,
      api_key: _key,
      expiration_date: new Date(end_d),
      start_date: new Date(start_d)
    };

    session.command(
      "companies/create_api_key",
      _data,
      {},
      { defaultErrorHandling: false }
    ).then(() => {
      toggleCreateNewApi();
      setShowApiCreateSuccess(true);
      setTimeout(() => {
        setShowApiCreateSuccess(false);
        setReloadTables(!reloadTables);
      }, 2000);
    }).catch((error) => {
      toggleCreateNewApi();
      console.log("Create API Key Failed", JSON.stringify(error));
      setReloadTables(!reloadTables);
    });
    
  }

  const onDeleteApiKey = (_api_delete) => {
    setApiToDelete(_api_delete);
    setApiShowModalDelete(true);
  }

  const onDeleteApiConfirmed = () => {
    session.command(
      "companies/delete_api_key",
      apiToDelete.id,
      {},
      { defaultErrorHandling: false }
    ).then(() => {
      setApiShowModalDelete(false);
      setShowApiDeleteSuccess(true);
      setTimeout(() => {
        setShowApiDeleteSuccess(false);
        setReloadTables(!reloadTables);
      }, 2000);
    }).catch((error) => {
      setApiShowModalDelete(false);
      console.log("Delete API Key Failed", JSON.stringify(error));
      setReloadTables(!reloadTables);
    });
  };

  useEffect(() => {
    const DeleteCurrent = () => { 
      return (
        <Alert color="warning" className="d-flex mb-n3i">
          This is the current API key,<br />
          are you sure you want<br /> to delete it?
        </Alert>
      )
    };
    if(apiToDelete) {
      let isCurrent = dayjs().isBetween( dayjs(apiToDelete.start_date), dayjs(apiToDelete.expiration_date).add(1, 'day') );
      if (isCurrent) {
        setApiToDeleteLabel(<DeleteCurrent />);
      } else {
        setApiToDeleteLabel("Delete this API Key?");
      }
    }
  }, [apiToDelete])

  /* 
   * IP functions 
  */

  const onCreateNewIp = (_ip) => {    
    let _data = {
      company_id: props.args.company_id,
      ip_address: _ip
    };

    session.command(
      "companies/create_ip_white_list",
      _data,
      {},
      { defaultErrorHandling: false }
    ).then(() => {
      toggleCreateNewIp();
      setShowIpCreateSuccess(true);
      setTimeout(() => {
        setShowIpCreateSuccess(false);
        setReloadTables(!reloadTables);
      }, 2000);
    }).catch((error) => {
      toggleCreateNewIp();
      console.log("Create IP Address Failed", JSON.stringify(error));
      setReloadTables(!reloadTables);
    });
  }

  const onEditIpAddress = (updated_ip) => {
    let _data = {
      id: editingIp.id,
      company_id: props.args.company_id,
      ip_address: updated_ip
    };

    session.command(
      "companies/update_ip_white_list",
      _data,
      {},
      { defaultErrorHandling: false }
    ).then(() => {
      toggleEditIp();
      setShowIpUpdateSuccess(true);
      setTimeout(() => {
        setShowIpUpdateSuccess(false);
        setReloadTables(!reloadTables);
      }, 2000);
    }).catch((error) => {
      toggleEditIp();
      console.log("Update IP Address Failed", JSON.stringify(error));
      setReloadTables(!reloadTables);
    });
  }

  const onEditIp = (_ip) => {
    setEditingIp(_ip);
    setEditIpIsOpen(true);
  }

  const onDeleteIpAddress = (_ip_delete) => {
    setIpToDelete(_ip_delete);
    setIpShowModalDelete(true);
  }

  const onDeleteIpConfirmed = () => {
    session.command(
      "companies/delete_ip_white_list",
      ipToDelete.id,
      {},
      { defaultErrorHandling: false }
    ).then(() => {
      setIpShowModalDelete(false);
      setShowIpDeleteSuccess(true);
      setTimeout(() => {
        setShowIpDeleteSuccess(false);
        setReloadTables(!reloadTables);
      }, 2000);
    }).catch((error) => {
      setIpShowModalDelete(false);
      console.log("Delete IP Address Failed", JSON.stringify(error));
      setReloadTables(!reloadTables);
    });
  }


  /* wait until done loading data before rendering */
  if(isLoadingLicenses) {
    return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <Button className="new-button" onClick={backToCompanyDetails} disabled={!editUrl.id}>
            <i className="bi bi-chevron-left"></i> Company Details
          </Button>
          <h1>Company API Access</h1>
          <i className="spacer" />
        </div>
        <div className="loading-text">Loading</div>
        <section className="loading-wrapper">
          <span style={animatedStyle}>
            <ProgressLoader />
          </span>
        </section>
      </div>
    )
  }

  return (
    <div className="page orders-page">
      <div className="list-header sticky-page-header">
        <Button className="new-button" onClick={backToCompanyDetails} disabled={!editUrl.id}>
          <i className="bi bi-chevron-left"></i> Company Details
        </Button>
        <h1>Company API Access</h1>
        <i className="spacer" />
      </div>

      <div className="mt-4 mb-4">
        <h4>
          &nbsp; Company: {companyInfo && <span style={nameStyle}>{companyInfo.name}</span>}
        </h4>
      </div>

      <div className="company-api-table-wrapper" key={reloadTables}>
        <div>
          <Button className="new-button move-inline" onClick={toggleCreateNewApi}>
            New API Key
          </Button>
          <DataTable
            query="companies/list_api_keys"
            params={{
              am_company_id: props.args.company_id,
              sort_by: "id",
              sort_asc: true,
            }}
            cols={table_columns_api}
            actions={table_actions_api}
            empty="No APIs Found"
          />
        </div>
        
        <div>
          <Button className="new-button move-inline" onClick={toggleCreateNewIp}>
            New IP Address
          </Button>
          <DataTable
            query="companies/list_ip_white_lists"
            params={{
              am_company_id: props.args.company_id,
            }}
            cols={table_columns_ip}
            actions={table_actions_ip}
            empty="No IPs Found"
          />
        </div>
      </div>

      <CreateNewApi
        close={toggleCreateNewApi}
        isOpen={createApiIsOpen}
        create={onCreateNewApi}
        companyId={props.args.company_id}
      />
      <CreateNewIpAddress
        close={toggleCreateNewIp}
        isOpen={createIpIsOpen}
        create={onCreateNewIp}
        companyId={props.args.company_id}
      />
      <EditIpAddress
        close={toggleEditIp}
        isOpen={editIpIsOpen}
        edit={onEditIpAddress}
        editIp={editingIp}
        companyId={props.args.company_id}
      />
    <ConfirmSuccess show={showApiCreateSuccess} label="API Key Created Successfully." />
    <ConfirmSuccess show={showApiDeleteSuccess} label="API Key Deleted Successfully." />
    <ConfirmDelete
      show={showApiModalDelete}
      label={apiToDeleteLabel}
      proceed={onDeleteApiConfirmed}
      cancel={() => {setApiShowModalDelete(false)}}
    />
    <ConfirmSuccess show={showIpCreateSuccess} label="IP Address Created Successfully." />
    <ConfirmSuccess show={showIpDeleteSuccess} label="IP Address Deleted Successfully." />
    <ConfirmSuccess show={showIpUpdateSuccess} label="IP Address Updated Successfully." />
    <ConfirmDelete
      show={showIpModalDelete}
      label="Delete IP Address?"
      proceed={onDeleteIpConfirmed}
      cancel={() => {setIpShowModalDelete(false)}}
    />
    </div>
  );
};

export default CompanyApiAccess;

/* new api key */
const CreateNewApi = ({close, isOpen, create, companyId}) => {
  const session = useContext(SessionContext);
  const [newCode, setNewCode] = useState();
  const [newStart, setNewStart] = useState("");
  const [newExpiration, setNewExpiration] = useState("");
  const [tooManyKeys, setTooManyKeys] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const generateNewKey = () => {
    setNewCode(uuidv4());
  }

  /** add a new key starting today, good for a year, defaults to start today */
  const addNewKey = (_start = dayjs().format('MMMM DD YYYY'), _end = dayjs().add(1, "year").format('MMMM DD YYYY')) => {
    setNewStart( _start );
    setNewExpiration( _end );
  }

  const checkValidateKeys = (_keys) => {
    // no keys:: add key
    if(!_keys.length) {
      addNewKey();
      return;
    } else {

      // remove all expired keys
      let valid_keys = [];
      _keys.forEach((key) => {
        if(dayjs().isBefore( dayjs(key.expiration_date).format('MMMM DD YYYY') )) {
          valid_keys.push({
            start: dayjs(key.start_date).format('MMMM DD YYYY'), 
            end: dayjs(key.expiration_date).format('MMMM DD YYYY')
          });
        }
      })

      // if all the keys are expired
      if(!valid_keys.length) {
        addNewKey();
        return;
      }

      // sort dates based on start date
      let sortedDates = valid_keys.sort((a, b) => dayjs(a.start).diff(dayjs(b.start)));

      // find the current key
      let current_key = null;
      sortedDates.forEach((key) => {
        if( dayjs().isBetween( dayjs(key.start), dayjs(key.end).add(1, 'day') ) ) {
          current_key = key;
        }
      })

      // if current key exist: and it's the only key
      if(current_key && sortedDates.length === 1) {
        addNewKey(
          dayjs(current_key.end).add(1, 'day').format('MMMM DD YYYY'), 
          dayjs(current_key.end).add(1, 'day').add(1, 'year').format('MMMM DD YYYY')
        );
        return;
      }

      // if current key exist and future key has a gap
      if(current_key && sortedDates.length > 1) {
        let current_key_ends = sortedDates[0].end;
        let future_key_starts = sortedDates[1].start;
        let gap = dayjs.duration(dayjs(current_key_ends).diff(future_key_starts)).asYears();

        // if there is no gap: don't add a new key
        if(dayjs.duration(dayjs(current_key_ends).diff(future_key_starts)).asDays() < 1) {
          setTooManyKeys(true);
          return;
        }

        if(gap < 1) { // the gap is less than a year
          addNewKey(
            dayjs(current_key_ends).add(1, 'day').format('MMMM DD YYYY'),
            dayjs( dayjs(future_key_starts).subtract(1, 'day') ).format('MMMM DD YYYY')
          );
        } else { // the gap is longer than a year
          addNewKey();
        }
        return;
      }

      // if no current key found: fill the space until next key starts
      if(!current_key && sortedDates.length > 0) {
        let next_key_starts = sortedDates[0].start;
        let gap = dayjs.duration(dayjs().diff(next_key_starts)).asYears();
        if(gap < 1) { // the gap less than a year
          addNewKey(
            dayjs().format('MMMM DD YYYY'),
            dayjs( dayjs(next_key_starts).subtract(1, 'day') ).format('MMMM DD YYYY')
          );
        } else { // the gap longer than a year
          addNewKey();
        }
        return;
      }
    }
  }

  const getAllExistingKeys = () => {
    let url = `companies/list_api_keys?am_company_id=${companyId}&filters=%7B%7D&sort_by=&sort_dir=desc`;
    session.query(url)
    .then((_apis) => {
      checkValidateKeys(_apis.rows);
      setTimeout(() => {
        setIsLoading(false);
      }, 600);
    })
    .catch((error) => {
      console.log("Failed to load the list of APIs")
      close();
    })
  }

  useEffect(() => {
    generateNewKey();
  }, [])

  useEffect(() => {
    generateNewKey();
    isOpen && getAllExistingKeys();
    !isOpen && setTooManyKeys(false);
    // eslint-disable-next-line
  }, [isOpen])

  if(isLoading) {
    return (<>
    <Modal centered isOpen={isOpen} backdrop>
    <ModalBody>
      <div className="p-5">
        <div className="loading-text">Loading</div>
        <section className="loading-wrapper">
          <span style={animatedStyle}>
            <ProgressLoader />
          </span>
        </section>
      </div>
    </ModalBody>
    </Modal>
    </>)
  }

  return (
    <Modal centered isOpen={isOpen} backdrop>
      <ModalHeader>
        Create New API Key
      </ModalHeader>
      <ModalBody>
        { tooManyKeys ? 
          <>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <div>Error: You have reached the maximum number of API keys for this company, one current API key and one future API key. If you need to create a new API key, please delete an existing one to proceed.</div>
            </Alert>
          </> : 
          <>
            <div>New API key:</div><br />
            <div className="text-center"><b>{newCode}</b></div>
            <div className="mt-3">
              <span className="api-key-label">Starts:</span> {newStart}
              <br />
              <span className="api-key-label">Expires:</span> {newExpiration}
            </div>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-lightbulb"></i>
              <div>Click Create to save the new API, or click Cancel to close this window.</div>
            </Alert>
          </>
        }
      </ModalBody>
      <ModalFooter>
        { tooManyKeys ? 
          <button onClick={close}>Close</button> : 
          <>
            <button onClick={close}>Cancel</button>
            <button className="promote" onClick={() => create(newCode, newStart, newExpiration)}>Create</button>
          </> }
      </ModalFooter>
    </Modal>
  )
}

/* new or edit ip address */
const CreateNewIpAddress = ({close, isOpen, create, companyId}) => {

  const session = useContext(SessionContext);
  const [newIp, setNewIp] = useState("");
  const [newIpIsValid, setNewIpIsValid] = useState(false);
  const [newIpIsDupe, setNewIpIsDupe] = useState(false);
  const [currentIps, setCurrentIps] = useState([]);

  useEffect(() => {
    let checkIp = ipv4Regex.test(newIp);
    let checkDupe = checkForDuplicateIPs(newIp, currentIps);
    setNewIpIsDupe(checkDupe);
    setNewIpIsValid(checkIp);
    // eslint-disable-next-line
  }, [newIp]);

  useEffect(() => {
    isOpen && getAllExistingIps();
    // eslint-disable-next-line
  }, [isOpen])

  const getAllExistingIps = () => {
    const _url = 'companies/get_all_white_list_ips';

    session.query(_url, { id: companyId })
      .then((list) => {
        if (list) {
          setCurrentIps(list);
        }
      });
  }

  const onCreate = () => {
    let _new_ip = newIp;
    setNewIp("");
    create(_new_ip);
  }

  const onClose = () => {
    setNewIp("");
    close();
  }

  const onInputChange = (ev) => {
    let _input = ev.target.value;
    const hasNumbersOnly = /^[0-9.]*$/;
    if (hasNumbersOnly.test(_input)) {
      setNewIp(_input)
    }
  }

  return (
    <Modal centered isOpen={isOpen} backdrop>
      <ModalHeader>
        Add New IP Address
      </ModalHeader>
      <ModalBody>
        <div>New IP Address:</div>
        <input
          type="text"
          value={newIp}
          className="new-ip-input"
          onChange={onInputChange}
        />
        <Alert color="danger" className="d-flex" isOpen={newIpIsDupe}>
          <i className="bi bi-exclamation-triangle-fill"></i>
          <div>
            The IP address <strong>{newIp}</strong> already exists.
          </div>
        </Alert>
        <Alert color="warning" className="d-flex">
          <i className="bi bi-lightbulb"></i>
          <div>
            Make sure the IP address is a unique and valid publicly routable address.
            <br />
            We only support IPv4 addresses at this time.
          </div>
        </Alert>
      </ModalBody>
      <ModalFooter>
        <button onClick={onClose}>Cancel</button>
        <button
          className="promote"
          onClick={onCreate}
          disabled={!newIpIsValid || newIpIsDupe}
        >Create</button>
      </ModalFooter>
    </Modal>
  );
}

const EditIpAddress = ({ close, isOpen, edit, editIp, companyId }) => {
  const session = useContext(SessionContext);
  const [newIp, setNewIp] = useState();
  const [newIpIsValid, setNewIpIsValid] = useState(false);
  const [newIpIsDupe, setNewIpIsDupe] = useState(false);
  const [currentIps, setCurrentIps] = useState([]);

  useEffect(() => {
    let checkIp = ipv4Regex.test(newIp);
    let dupe = checkForDuplicateIPs(newIp, currentIps);
    setNewIpIsDupe(dupe && (editIp && newIp !== editIp.ip_address));
    setNewIpIsValid(checkIp && (editIp && newIp !== editIp.ip_address));
    // eslint-disable-next-line
  }, [newIp]);

  useEffect(() => {
    isOpen && getAllExistingIps();
    // eslint-disable-next-line
  }, [isOpen])

  useEffect(() => {
    if(editIp && "ip_address" in editIp && !newIp) {
      setNewIp(editIp.ip_address);
    }
    // eslint-disable-next-line
  }, [editIp])

  const getAllExistingIps = () => {
    const _url = 'companies/get_all_white_list_ips';

    session.query(_url, { id: companyId })
      .then((list) => {
        if (list) {
          setCurrentIps(list);
        }
      });
  }

  const onEdit = () => {
    let _new_ip = newIp;
    setNewIp("");
    edit(_new_ip);
  }

  const onClose = () => {
    setNewIp("");
    close();
  }

  const onInputChange = (ev) => {
    let _input = ev.target.value;
    const hasNumbersOnly = /^[0-9.]*$/;
    if (hasNumbersOnly.test(_input)) {
      setNewIp(_input)
    }
  }

  return (
    <Modal centered isOpen={isOpen} backdrop>
      <ModalHeader>
        Edit IP Address
      </ModalHeader>
      <ModalBody>
        <div>IP Address</div>
        <input
          type="text"
          value={newIp}
          className="new-ip-input"
          onChange={onInputChange}
        />
        <Alert color="danger" className="d-flex" isOpen={newIpIsDupe}>
          <i className="bi bi-exclamation-triangle-fill"></i>
          <div>
            The IP address <strong>{newIp}</strong> already exists.
          </div>
        </Alert>
        <Alert color="warning" className="d-flex">
          <i className="bi bi-lightbulb"></i>
          <div>
            Make sure the IP address is a unique and valid publicly routable address.
            <br />
            We only support IPv4 addresses at this time.
          </div>
        </Alert>
      </ModalBody>
      <ModalFooter>
        <button onClick={onClose}>Cancel</button>
        <button
          className="promote"
          onClick={onEdit}
          disabled={!newIpIsValid || newIpIsDupe}
        >Update</button>
      </ModalFooter>
    </Modal>
  );
}

const checkForDuplicateIPs = (_ip, currentIps) => {
  if (!_ip || !currentIps) return false;
  let dupe = false;
  const found = currentIps.find((element) => element.ip_address === _ip);
  if (found) dupe = true;
  return dupe;
}